import React from "react";
import styles from "./styles.module.scss";

const Brandkit: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.heading}>Brandkit</div>
          <div className={styles.subHeading}>
            Define your brand identity — colors, fonts, and assets.
          </div>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.emptyState}>
          <p className={styles.emptyText}>Coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default Brandkit;
